var _style, _defs, _path, _path2, _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQ7({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000140005596669621030270000017030468701291518086_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155.1 154.9",
    style: {
      enableBackground: "new 0 0 155.1 154.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000165198589338848646920000001282301162788528531_);}\n\t.st1{fill:#36A7DC;}\n\t.st2{fill:#F4AC74;}\n\t.st3{fill:#E4E4E5;}\n\t.st4{fill:#EE9E83;}\n\t.st5{fill:#B24F2F;}\n\t.st6{fill:#50A2CA;}\n\t.st7{fill:#551F03;}\n\t.st8{fill:#903B1F;}\n\t.st9{fill:#B14E2D;}\n\t.st10{fill:#EA9B84;}\n\t.st11{fill:#63A4C5;}\n\t.st12{fill:#663D2B;}\n\t.st13{fill:none;stroke:#002A33;stroke-width:8;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 78.3,
    cy: 77.1,
    r: 71.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116225266037775608110000000130981820624876946_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000116225266037775608110000000130981820624876946_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.6,156L149.6,156c2.7,0,5.4,0,8.1,0c1.5,0,2.6-0.7,3.1-2.2c0.4-1.5-0.4-2.4-1.5-3.3 c-0.4-0.3-0.9-0.9-1-1.4c-0.6-2.2-2.1-3.3-4.3-2.9c-0.9,0.2-1.4,0.1-2.1-0.7c-2.9-3.3-7.6-2.4-9.2,1.8c-0.2,0.4-0.7,0.9-1.1,1 c-2.7,0.4-4.2,1.8-4.1,3.9c0.1,2.3,1.8,3.7,4.5,3.7C144.6,156.1,147.1,156,149.6,156L149.6,156z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.9,117.5c-0.2-0.1-0.5-0.3-0.8-0.4c0.3-0.1,0.6-0.2,0.8-0.3C11.9,117,11.9,117.3,11.9,117.5L11.9,117.5z "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3.2,
    className: "st3",
    width: 153.9,
    height: 146
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M150.9,135.4c-0.4,0.5-0.9,0.9-1,1.4c-0.6,2.7-1.3,2.7-3.8,3.9c-2,0.9-4,0.6-5.9,0.9 c-0.4,0.1-0.9-0.3-1.4-0.4c0.2-0.5,0.3-1.1,0.5-1.6c0.4-1.5,0.9-2.9,1.3-4.4c0.4-0.2,1.1-0.4,1.3-0.7c1.8-2.9,4.7-3.2,7.6-3.2 c0.5,0,0.9,0,1.4,0L150.9,135.4L150.9,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.2,146.8c0.1,0.6,0.3,1.1,0.4,1.7H53.8c0-0.1,0-0.2,0-0.3c0.8-0.1,1.6-0.3,2.3-0.3 c15.6,0,31.2,0,46.9,0C103.9,147.8,104.9,148,105.2,146.8L105.2,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M140.6,135.2c-0.4,1.5-0.9,2.9-1.3,4.4c-0.2,0.5-0.3,1.1-0.5,1.6c-0.6,0.2-1.1,0.5-1.6,0.4 c-7.7-1.4-15.4-2.7-23.2-4.2c-2.6-0.5-5.1-1.3-7.6-2c-0.6-0.2-1.2-0.3-1.8-0.5c-0.2-2.2-0.4-4.3-0.7-6.5c0-1.8-0.1-3.6-0.1-5.3 c0-1.3-0.5-2-2.1-1.9c-5.3,0.1-10.6,0.1-15.8,0.1c-3.7,0-7.3,0.1-11,0.1c-5.1,0-10.1,0.1-15.1,0.1L54,109.4 c-0.2,0.1-0.5,0.1-0.8,0.2v11.9c-3.3-0.1-6.6-0.1-9.9-0.2l0-2.8c-0.3-4.8-0.6-9.6-0.8-14.4c-0.4-7.3-1.2-14.6,0.7-22 c0.8-3.3,2.8-4.7,5.8-5.2c0.6-0.1,1.1-0.2,1.7-0.2c0.9,1,1.7,0.4,2.4-0.2c0.6-0.1,1.2-0.1,1.7-0.2c1.5,0.7,2.8,0.2,4.1-0.6 c0.2-0.1,0.5-0.1,0.7-0.1c1,0.7,1.6,0.3,2.1-0.6c0.3-0.2,0.7-0.3,1-0.4c0.2-0.1,0.5-0.2,0.7-0.3l0,0c0.1-0.1,0.2-0.2,0.3-0.3 c0.2-0.2,0.4-0.3,0.6-0.5c1.8,0.2,3.5,0.3,3.8-1.7c4.6,1.4,9,2.1,13.5,1c0.2,0.3,0.5,0.6,0.8,0.9c0.1,0.1,0.2,0.3,0.4,0.4v0 c0.2,0.4,0.3,0.9,0.6,1.1c0.8,0.4,1.7,1,2.5,1c1.5,0,2.5,1.9,4.1,0.8c0.4,0.1,0.8,0.2,1.1,0.2c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3,0.1c0.5,1.2,1.3,0.7,2.1,0.4c0.3,0.1,0.7,0.1,1,0.1c0.2,0.1,0.5,0.1,0.7,0.2c0.2,0,0.5,0.1,0.7,0.1 c1.1,0.4,2.2,0.8,3.3,1.2c0.1,0,0.1,0,0.2,0.1c0.2,0.2,0.5,0.4,0.7,0.7l0,0c0.3,0.5,0.7,0.9,1,1.4c0.1,0,0.1,0.1,0.1,0.2 c0.3,0.5,0.6,1,0.9,1.5c0.1,0.2,0.1,0.4,0.1,0.5c0.5,1.6,1,3.1,1.5,4.6c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.5,0.2,0.7 c0.1,0.3,0.1,0.7,0.2,1c0.2,1,0.4,2.1,0.6,3.1c0,0.3,0.1,0.7,0.1,1c-0.4,0.9-0.8,1.8,0.3,2.4c0.5,4.7,0.9,9.5,1.4,14.2 c0.5,3.9,1.1,7.7,1.8,11.5c0.1,0.6,1,1.2,1.6,1.5c3.7,1.3,7.5,2.3,11.1,3.6c4,1.5,7.9,3.3,12,4.9 C135.8,133.9,138.2,134.5,140.6,135.2L140.6,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.5,64c-0.3-0.1-0.6-0.1-0.9-0.2c-0.5-0.3-1-0.8-1.5-0.9c-2.3-0.5-4-1.7-4.6-4 c-1.3-4.7-1.5-9.5-1.1-14.4c0.4-4.6,1.1-9.2,3-13.5c0.8-1.9,1.7-3.9,2.5-5.8v0c0.2-0.3,0.4-0.6,0.6-0.9c0-0.1,0-0.1,0.1-0.2 c0.4-0.5,0.9-1,1.3-1.5c0.2-0.2,0.4-0.4,0.7-0.6c0.2,0,0.5,0,0.7-0.1c3.2-2.5,7-3.6,11-4c0.3,0,0.6-0.4,0.9-0.5 c0.2,0,0.5,0,0.7,0c1.1,0,2.3,0,3.4,0c0.5,0,0.9,0.1,1.4,0.1c1.4,0.4,2.8,0.8,4.1,1.2c1.7,0.5,3.3,1.1,4.9,1.7 c0.1,0,0.2,0,0.2,0.1c0.7,1,1.2,2.3,2.2,2.9c2.1,1.2,3.1,3.2,3.9,5.2c1.7,4.1,3,8.3,3.6,12.7c0,0.2,0.3,0.4,0.5,0.6 c0,0.2,0.1,0.5,0.1,0.7C97.2,43,97,43.7,97,44.3c0.1,4.4,0.2,8.8,0.3,13.2c0,1.2,0,2.4-0.1,3.7c0,0.2-0.1,0.5-0.1,0.7 c-0.4,0.6-0.8,1.5-1.4,1.7c-1.3,0.4-2.8,0.3-4.2,0.5c-1.8,0.3-3.6,0.6-5.4,0.9c-0.2,0-0.5,0.1-0.7,0.1c-0.3,0-0.7,0-1,0 c-3,0.1-6,0.2-9,0.3c-0.7,0-1.4,0-2.1,0c-2.3-0.1-4.6-0.2-6.9-0.3c-1.4-0.8-2.9-1.3-4.5-0.5c-0.2,0-0.5-0.1-0.7-0.1L59.5,64 L59.5,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M103.8,128.4c0.2,2.2,0.4,4.3,0.7,6.5c0,0.8,0,1.7,0,2.5c0,0.2,0,0.4,0.1,0.7c0.1,1.4,0.2,2.8,0.3,4.1 c0,0.4,0.1,0.7,0.1,1.1c0.1,1.1,0.2,2.3,0.2,3.5c-0.3,1.2-1.3,1-2.2,1c-15.6,0-31.2,0-46.9,0c-0.8,0-1.6,0.2-2.3,0.3 c-0.1-0.2-0.3-0.4-0.4-0.7c0-0.2-0.1-0.5-0.2-0.7c-1.3-3.4-2.5-6.8-3.8-10.2v-0.1l-0.1-0.1c-0.5-0.8-1-1.5-1.4-2.3l0-0.1 c-0.4-0.5-0.8-1-1.2-1.4c-0.7-0.7-1.4-1.4-2.2-2c-0.2-0.2-0.4-0.3-0.6-0.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.6-0.4-1.1-0.8-1.7-1.3 c0.8,0,1.5-0.1,2.2-0.1C64,128.5,83.9,128.4,103.8,128.4L103.8,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M103.8,128.4c-19.9,0-39.9,0-59.8,0c-0.8,0-1.5,0.1-2.2,0.1c-2.2-1-4.4-1.9-6.7-2.9l0,0 c-0.1-0.1-0.2-0.2-0.3-0.4h0c-0.1-0.2-0.3-0.4-0.4-0.6c0-0.1-0.1-0.2-0.1-0.4c0-0.3,0-0.7,0-1c0.1-0.1,0.1-0.2,0.1-0.3 c1.5-0.5,2.9-1.2,4.4-1.5c1.4-0.3,3-0.2,4.4-0.2c3.3,0.1,6.6,0.1,9.9,0.2c2.1,0,4.3,0.1,6.4,0.1c5,0,10.1-0.1,15.1-0.1 c3.7,0,7.3-0.1,11-0.1c5.3,0,10.6,0,15.8-0.1c1.6,0,2,0.6,2.1,1.9C103.8,124.9,103.8,126.7,103.8,128.4L103.8,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M66.6,65c2.3,0.1,4.6,0.2,6.9,0.3c0.7,0,1.4,0,2.1,0c3-0.1,6-0.2,9-0.3c0,0.1,0.1,0.2,0.1,0.3 c-0.8,0.5-1.5,1.4-2.3,1.5c-1.6,0.2-1.7,1.1-1.6,2.3c0,0.4,0,0.9,0,1.4c-4.9-0.1-9.7-0.2-14.6-0.2c0-1.7-0.1-3.3-0.1-5 C66.1,65.1,66.4,65,66.6,65L66.6,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M66,70.2c4.9,0.1,9.7,0.2,14.6,0.2c0.4,0.8,0.7,1.6,1.1,2.4c-4.6,1.1-9,0.4-13.5-1 c-0.3,2-2.1,1.8-3.8,1.7C64.9,72.4,65.5,71.3,66,70.2L66,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M56.9,25.2c-0.8,1.9-1.7,3.9-2.5,5.8c-1.9,4.3-2.6,8.9-3,13.5c-0.4,4.8-0.2,9.6,1.1,14.3 c0.7,2.3,2.3,3.5,4.6,4c0.5,0.1,1,0.6,1.5,0.9c-1.5-0.5-3.1-0.8-4.6-1.4c-0.7-0.3-1.2-1.2-1.5-1.9c-1.5-4-1.9-8.3-1.8-12.5 c0.1-7.1,1.2-14,4.6-20.5C55.8,26.7,56.4,26,56.9,25.2L56.9,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.2,41.8c-0.2-0.2-0.5-0.4-0.5-0.6c-0.6-4.4-1.9-8.6-3.6-12.7c-0.9-2-1.9-4-3.9-5.2 c-0.9-0.6-1.5-1.9-2.2-2.9c2.9,1.5,4.6,4.1,6,6.8C95.4,31.8,96.7,36.7,97.2,41.8L97.2,41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.2,61.1c0-1.2,0.1-2.4,0.1-3.7c-0.1-4.4-0.2-8.8-0.3-13.2c0-0.6,0.2-1.2,0.3-1.8 C98.3,48.7,98.3,54.9,97.2,61.1L97.2,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.3,64.9c1.8-0.3,3.6-0.7,5.4-0.9c1.4-0.2,2.8-0.1,4.2-0.5c0.6-0.2,0.9-1.1,1.4-1.7 c0.1,1.7-0.6,2.5-2.4,2.6C91.9,64.4,89.1,64.7,86.3,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.1,17.3c-0.3,0.2-0.6,0.5-0.9,0.5c-4,0.4-7.7,1.5-11,4C60.1,22,59.8,22,59.6,22 c2.5-2.9,5.9-3.7,9.5-4.4C70,17.4,71.1,17.4,72.1,17.3L72.1,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M86.7,20.3c-1.7-0.6-3.3-1.2-4.9-1.7c-1.4-0.4-2.8-0.8-4.1-1.2C80.9,17.7,84,18.4,86.7,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M90.1,77c-1.6,1.1-2.7-0.8-4.1-0.8c-0.8,0-1.7-0.5-2.5-1c-0.3-0.2-0.4-0.7-0.6-1.1 C85.3,75.1,87.7,76.1,90.1,77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M66.6,65c-0.2,0.1-0.4,0.1-0.7,0.2c-1.3-0.2-2.6-0.5-3.8-0.7C63.7,63.7,65.2,64.2,66.6,65L66.6,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M59,75.8c-1.3,0.8-2.6,1.3-4.1,0.6C56.2,76.2,57.6,76,59,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104,88.4c-0.5-1.6-1-3.1-1.5-4.6C103,85.3,103.5,86.9,104,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M76.2,17.3c-1.1,0-2.3,0-3.4,0C73.9,17.3,75.1,17.3,76.2,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.1,93.9c-0.2-1-0.4-2.1-0.6-3.1C104.7,91.9,104.9,92.9,105.1,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M99.6,79.4c-1.1-0.4-2.2-0.8-3.3-1.2C97.4,78.6,98.5,79,99.6,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.6,97.4c-1.1-0.7-0.7-1.5-0.3-2.4C105.3,95.8,105.5,96.6,105.6,97.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.1,76.5c-0.7,0.7-1.5,1.2-2.4,0.2C51.5,76.6,52.3,76.6,53.1,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M61.7,75c-0.5,0.9-1.1,1.3-2.1,0.6C60.3,75.4,61,75.2,61.7,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.8,77.7c-0.8,0.3-1.6,0.8-2.1-0.4C92.5,77.5,93.2,77.6,93.8,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M58.9,22.7c-0.4,0.5-0.9,1-1.3,1.5C58,23.7,58.5,23.2,58.9,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M59.5,64l1.9,0.4C60.8,64.2,60.2,64.1,59.5,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M84.6,65.3c0-0.1,0-0.2-0.1-0.3c0.3,0,0.7,0,1,0C85.2,65.1,84.9,65.2,84.6,65.3L84.6,65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M102.4,83.2c-0.3-0.5-0.6-1-0.9-1.5C101.8,82.2,102.1,82.7,102.4,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.4,81.5c-0.3-0.5-0.7-0.9-1-1.4C100.8,80.6,101.1,81,101.4,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M57.5,24.3c-0.2,0.3-0.4,0.6-0.6,0.9C57.1,24.9,57.3,24.6,57.5,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104.3,89.8c-0.1-0.2-0.1-0.5-0.2-0.7C104.2,89.3,104.3,89.6,104.3,89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.6,78.1c-0.2-0.1-0.5-0.1-0.7-0.2C95.1,77.9,95.3,78,95.6,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M63.4,74.2c-0.2,0.1-0.5,0.2-0.7,0.3C63,74.4,63.2,74.3,63.4,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.4,80.1c-0.2-0.2-0.5-0.4-0.7-0.7C100,79.7,100.2,79.9,100.4,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M91.5,77.3c-0.1,0-0.2,0-0.3-0.1C91.3,77.3,91.4,77.3,91.5,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M82.9,74.2c-0.1-0.1-0.2-0.3-0.4-0.4C82.6,73.9,82.7,74.1,82.9,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M63.8,73.9c-0.1,0.1-0.2,0.2-0.3,0.3C63.6,74.1,63.7,74,63.8,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105,143.4c0-0.4-0.1-0.7-0.1-1.1C104.9,142.7,105,143,105,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.6,138.1c0-0.2,0-0.4-0.1-0.7C104.6,137.7,104.6,137.9,104.6,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.5,65.3c-0.7,0-1.4,0-2.1,0C74.2,65.3,74.9,65.3,75.5,65.3z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 77.4,
    cy: 77.4,
    r: 73.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ7);
export default __webpack_public_path__ + "static/media/q7.fcf9fcd4995ff112897cbeb06bd13b71.svg";
export { ForwardRef as ReactComponent };